import { useUrlGenerator } from '@folklore/routes';
import { getComponentFromName } from '@folklore/utils';
import classNames from 'classnames';
import type { FC } from 'react';
import { Link } from 'wouter';

import BrandLogoHeader from '../icons/BrandLogoHeader';
import Menu from '../menus/Menu';

import styles from '../../styles/headers/brand-header.module.css';

import urbaniaLogo from '../../assets/img/brands/urbania_logo.svg';
// import dehorsSponsor from '../../assets/img/sponsors/dehors_menu_sponsor.svg';
import { ReactComponent as DehorsSponsor } from '../../assets/img/sponsors/dehors_header_sponsor.svg';
import quatre95Sponsor from '../../assets/img/sponsors/quatre95_home_sponsor.svg';

const BrandsSponsors: Record<string, FC<{ className?: string }>> = {
    Quatre95: ({ className }: { className?: string }) => (
        <a
            href="https://ad.doubleclick.net/ddm/clk/555271275;364229366;p?https://www.bnc.ca/particuliers/conseils.html?cid=dis_26253292_364229366_555271275_%ecid!"
            target="_blank"
            rel="noopener noreferrer"
        >
            <img src={quatre95Sponsor} className={classNames(className)} alt="Banque Nationale" />
        </a>
    ),
    Dehors: ({ className, ...props }: { className?: string }) => (
        <a
            href="https://www.achetermatoyota.ca/quebec/fr"
            target="_blank"
            rel="noopener noreferrer"
        >
            <DehorsSponsor className={classNames(className)} {...props} />
        </a>
    ),
};

interface BrandHeaderProps {
    handle: string;
    label: string;
    slug: string;
    sections?: Section[] | null;
    section?: Section | null;
    withoutSections?: boolean;
    className?: string;
}

const BrandHeader: FC<BrandHeaderProps> = ({
    handle,
    slug,
    sections,
    withoutSections = false,
    className,
}) => {
    const url = useUrlGenerator();
    // const { id: sectionId = null } = section || {};
    const SponsorComponent = getComponentFromName(BrandsSponsors, handle);
    const withUrbaniaLogo = handle !== 'urbania' && handle !== 'france' && handle !== 'quatre95';
    const hasVerticalLogo = handle === 'periodelibre';
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.hasVerticalLogo]: hasVerticalLogo,
                    [styles.withUrbania]: withUrbaniaLogo,
                },
                styles[handle],
                className,
            ])}
        >
            {withUrbaniaLogo ? (
                <Link href="/" className={styles.urbania}>
                    <img src={urbaniaLogo} className={styles.urbaniaLogo} alt="URBANIA" />
                </Link>
            ) : null}
            <div className={styles.inner}>
                <div className={styles.logoContainer}>
                    <BrandLogoHeader brand={handle} className={styles.logo} />
                    {hasVerticalLogo ? (
                        <BrandLogoHeader
                            brand={handle}
                            vertical
                            className={classNames([styles.logo, styles.logoVertical])}
                        />
                    ) : null}
                </div>
                {SponsorComponent !== null ? (
                    <div className={styles.sponsorContainer}>
                        <SponsorComponent fill="currentColor" className={styles.sponsor} />
                    </div>
                ) : null}
                {!withoutSections ? (
                    <Menu
                        items={(sections || [])
                            .filter(({ hidden = false }) => !hidden)
                            .map(({ id, label: sectionLabel, slug: sectionSlug }) => ({
                                id,
                                label: sectionLabel,
                                href: url('section', {
                                    brand: slug,
                                    section: sectionSlug,
                                }),
                            }))}
                        className={styles.sectionsMenu}
                        itemsClassName={styles.sections}
                        itemClassName={styles.section}
                        buttonClassName={styles.button}
                    />
                ) : null}
            </div>
        </div>
    );
};

export default BrandHeader;
